import { render } from "./summary.vue?vue&type=template&id=4160fb32&scoped=true&ts=true"
import script from "./summary.vue?vue&type=script&lang=ts"
export * from "./summary.vue?vue&type=script&lang=ts"

import "./summary.vue?vue&type=style&index=0&id=4160fb32&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4160fb32"]])

export default __exports__